import api from './api';

export const getMyFamilyGroups = ()                  => api.get('/api/family');
export const createFamilyGroup = name                => api.post('/api/family', { name });
export const inviteFamilyMember = (groupId, email, role) =>
  api.post(`/api/family/${groupId}/invite`, { email, role });
export const acceptInvitation  = token               => api.post(`/api/family/accept/${token}`);
export const getMemberProfile  = (groupId, memberId) => api.get(`/api/family/${groupId}/members/${memberId}/profile`);
export const getMemberPets     = (groupId, memberId) => api.get(`/api/family/${groupId}/members/${memberId}/pets`);
export const updateMemberPerms = (groupId, memberId, perms) =>
  api.put(`/api/family/${groupId}/members/${memberId}`, perms);
export const removeMember      = (groupId, memberId) => api.delete(`/api/family/${groupId}/members/${memberId}`);
